
<template>
  <div>
    <div
      v-if="table && table.TableId && !isAdminComponent"
      :id="'rtbl_' + table.TableId"
      :class="'rt-comp ' + pageId"
    >
      <div v-show="showHeader == true" class="rt-comp-header">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <h5 v-on="on">{{ table.TableName }}</h5>
          </template>
          <span class="v-tooltip-content v-tooltip-top">{{
            table.TableName
          }}</span>
        </v-tooltip>
        <!--{{ table.Capacity }}/{{ table.Occupied }}-->
        <p v-if="showSeatAvailability && table.Occupied == 0" class="m-0">
          Be the first to join
        </p>
        <p
          v-else-if="
            showSeatAvailability && table.Capacity - table.Occupied == 0
          "
          class="m-0"
        >
          <v-icon left> mdi-sofa-single </v-icon>
          No Slots Available
        </p>
        <!--<p v-else-if="showSeatAvailability && table.Capacity - table.Occupied == 1" class=m-0>
        <v-icon left> mdi-sofa-single </v-icon>1 Slot Available
      </p>-->
        <p v-else class="m-0">
          <v-icon left> mdi-sofa-single </v-icon>
          {{ table.Capacity - table.Occupied }}
          {{
            table.Capacity - table.Occupied == 1
              ? " Slot Available"
              : " Slot (s) Available"
          }}
        </p>
      </div>
      <div
        :class="'rt-comp-body ' + table.JoinButtonClass"
        @click="JoinRT(table.TableId, table.SessionId)"
      >
        <v-img src="../assets/Images/rt-seat.jpg" class="rt-comp-chair"></v-img>
        <div class="rt-comp-logo">
          <v-img
            v-if="table.RoundtableLogo"
            :src="getCDNUrl(table.RoundtableLogo)"
          ></v-img>
          <v-img v-else src="../assets/Images/rt-logo.png"></v-img>
        </div>
      </div>
      <div
        v-show="showFooter"
        class="rt-comp-footer"
        @click="JoinRT(table.TableId, table.SessionId)"
      >
        <a href="javascript:void(0);" :class="table.JoinButtonClass">
          {{ table.JoinButtonLabel }}
        </a>
      </div>
    </div>
    <!---RT self service-->
    <div
      v-if="table && table.TableId && isAdminComponent"
      :id="'rtbl_' + table.TableId"
      class="
        d-lg-flex
        align-items-center
        full-width
        justify-content-between
        flex-lg-nowrap
      "
    >
      <div class="left-side-admin-rt">
        <div class="admin-rt-img">
          <img src="https://bni.e2m.live/img/rt-seat.ac8da594.jpg" alt="img" />
          <!---->
          <div class="rt-comp-logo">
            <v-img
              v-if="table.RoundtableLogo"
              :src="getCDNUrl(table.RoundtableLogo)"
            ></v-img>
            <v-img v-else src="../assets/Images/rt-logo.png"></v-img>
          </div>
          <!---->
        </div>
        <div class="admin-rt-name">
          <h3>
            {{ table.TableName }}
          </h3>
          <p>Host: {{ table.HostName }}</p>
        </div>
      </div>
      <div class="center-side-admin-rt">
        <div class="center-left">
          <p v-if="table.PreAssigned">Pre-assigned Table</p>
          <p v-else>Open Table</p>
        </div>
        <p>{{ table.Capacity }} seats</p>
        <p>Streaming on {{ table.StreamingClient }}</p>
      </div>
      <div class="right-side-admin-rt">
        <div class="attendee-status-switch mr-0 d-flex align-items-center">
          <p><strong>Status</strong></p>
          <v-switch
            color="#1a73e8"
            v-model="table.IsPublished"
            :loading="table.IsStatusChanging"
            @change="
              table.IsStatusChanging = true;
              changeTableStatus(table.TableId, table.IsPublished);
            "
          ></v-switch>
        </div>
        <div class="attendee-edit-dlt ml-2">
          <v-btn small icon class="mr-3" @click="EditRT(table.TableId)">
            <img src="../assets/Images/self-service/edit-self.svg" />
          </v-btn>
          <v-btn
            small
            icon
            :loading="table.IsDeleting"
            @click="deleteTable(table.TableId)"
          >
            <img src="../assets/Images/self-service/delete-self.svg" />
          </v-btn>
        </div>
      </div>
    </div>
    <!---RT self service end-->
  </div>
</template>

<script>
export default {
  props: {
    pageId: {
      type: String,
      default: () => "",
    },
    showHeader: {
      type: Boolean,
      default: () => true,
    },
    showSeatAvailability: {
      type: Boolean,
      default: () => true,
    },
    showFooter: {
      type: Boolean,
      default: () => true,
    },
    isAdminComponent: {
      type: Boolean,
      default: () => false,
    },
    table: {
      type: Object,
      default: () => ({
        TableId: "",
        SessionId: "",
        TableName: "",
        RoundtableLogo: "",
        Capacity: 0,
        Occupied: 0,
        JoinButtonClass: "",
        JoinButtonLabel: "",
        HostId: "",
        HostName: "",
        StreamingClient: "",
        PreAssigned: false,
        IsPublished: false,
      }),
    },
  },
  methods: {
    JoinRT(tableId, sessionId) {
      this.$emit("JoinRT", tableId, sessionId);
    },
    EditRT(tableId) {
      this.$emit("OpenAddRTPopup", tableId);
    },
    changeTableStatus(tableId, isPublished) {
      this.$emit("changeTableStatus", tableId, isPublished);
    },
    deleteTable(tableId) {
      this.$emit("deleteTable", tableId);
    },
  },
};
</script>

<style>
.rt-comp {
  min-height: 140px;
  min-width: 140px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #dfdfdf;
  border-radius: 10px;
  overflow: hidden;
  background: #fff !important;
}
.rt-comp-header {
  width: 100%;
  text-align: center;
  background: #eaeef1;
  padding: 6px 0;
}
.rt-comp-header h5 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #000;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 8px;
}
.rt-comp-header p {
  margin: 0;
  font-size: 14px;
  font-weight: 300;
  color: #000;
}
.exrt .rt-comp-header p {
  font-size: 12px;
}
.rt-comp-body {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  background: #fff !important;
}
.rt-comp-body .rt-no-slots {
  cursor: text;
}
.rt-comp-chair {
  max-height: 140px !important;
  max-width: 140px !important;
}
.rt-comp-logo {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-51.5%, -50%);
  height: 60px;
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rt-comp-footer {
  width: 100%;
}
.rt-comp-footer a {
  width: 100%;
  text-align: center;
  display: block;
  padding: 8px 0;
  background: #82c28e;
  color: #000 !important;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 18px;
}
.rt-comp-footer a.rt-no-slots {
  background: #f89387 !important;
  cursor: text;
}
.rt-comp-footer a.rt-spectate {
  background: #e6cb7b;
}
</style>